"use client";

import { Typography, WhatsAppLogo } from "@drpcrd/shared/ui";
import { FadeInSection } from "../fade-in-section";
import { SectionEyebrow } from "../section-eyebrow";
import { TestimonialQuote } from "../testimonial-quote";
import {
  CreatorVideoCarousel,
  type CreatorVideoItem,
} from "../creator-video-carousel/creator-video-carousel";
import isaacHpAvatar from "./assets/isaac-hp.png";
import zacAslopImg from "./assets/creator-carousel/zac-aslop.webp";
import harryPineroImg from "./assets/creator-carousel/harry-pinero.webp";
import lukeVernonImg from "./assets/creator-carousel/luke-vernon.webp";
import leightonWhyteImg from "./assets/creator-carousel/leighton-whyte.webp";
import mattGreenImg from "./assets/creator-carousel/matt-green.webp";
import staraHendricksImg from "./assets/creator-carousel/stara-hendricks.webp";
import sensationalSandwichesImg from "./assets/creator-carousel/sensational-sandwiches.webp";
import monicaGeldartImg from "./assets/creator-carousel/monica-geldart.webp";
import krystalDanjouImg from "./assets/creator-carousel/krystal-danjou.webp";
import isaacHpImg from "./assets/creator-carousel/isaac-hp.webp";
import grimeGranImg from "./assets/creator-carousel/grime-gran.webp";
import gadgetsBoyImg from "./assets/creator-carousel/gadgets-boy.webp";
import saskiaMarriottImg from "./assets/creator-carousel/saskia-marriott.webp";
import dAndLishImg from "./assets/creator-carousel/d-and-lish.webp";
import colinfurzeImg from "./assets/creator-carousel/colinfurze.webp";
import aaronTheLocoImg from "./assets/creator-carousel/aaron-the-loco.webp";
import aceOfSpoonsImg from "./assets/creator-carousel/ace-of-spoons.webp";
import dGradeImg from "./assets/creator-carousel/d-grade.webp";
import fredAsquithImg from "./assets/creator-carousel/fred-asquith.webp";
import domFutbolImg from "./assets/creator-carousel/dom-futbol.webp";
import moyoImg from "./assets/creator-carousel/moyo.webp";
import leilaLayzellImg from "./assets/creator-carousel/leila-layzell.webp";
import samLewisImg from "./assets/creator-carousel/sam-lewis.webp";
import millyPicklesImg from "./assets/creator-carousel/milly-pickles.webp";

const CREATOR_MEDIA_BY_ID: Record<number, { image: string; videoUrl: string }> =
  {
    46743: {
      image: zacAslopImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/zac-aslop.webm",
        import.meta.url,
      ).toString(),
    },
    464433222: {
      image: harryPineroImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/harry-pinero.webm",
        import.meta.url,
      ).toString(),
    },
    73633: {
      image: lukeVernonImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/luke-vernon.webm",
        import.meta.url,
      ).toString(),
    },
    86120: {
      image: leightonWhyteImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/leighton-whyte.webm",
        import.meta.url,
      ).toString(),
    },
    34470: {
      image: mattGreenImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/matt-green.webm",
        import.meta.url,
      ).toString(),
    },
    23159474: {
      image: staraHendricksImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/stara-hendricks.webm",
        import.meta.url,
      ).toString(),
    },
    165698352: {
      image: sensationalSandwichesImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/sensational-sandwiches.webm",
        import.meta.url,
      ).toString(),
    },
    101: {
      image: monicaGeldartImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/monica-geldart.webm",
        import.meta.url,
      ).toString(),
    },
    54115: {
      image: krystalDanjouImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/krystal-danjou.webm",
        import.meta.url,
      ).toString(),
    },
    112: {
      image: isaacHpImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/isaac-hp.webm",
        import.meta.url,
      ).toString(),
    },
    1092419119: {
      image: grimeGranImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/grime-gran.webm",
        import.meta.url,
      ).toString(),
    },
    533287302: {
      image: gadgetsBoyImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/gadgets-boy.webm",
        import.meta.url,
      ).toString(),
    },
    120: {
      image: saskiaMarriottImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/saskia-marriott.webm",
        import.meta.url,
      ).toString(),
    },
    12443926: {
      image: dAndLishImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/d-and-lish.webm",
        import.meta.url,
      ).toString(),
    },
    521958831: {
      image: colinfurzeImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/colinfurze.webm",
        import.meta.url,
      ).toString(),
    },
    23159511: {
      image: aaronTheLocoImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/aaron-the-loco.webm",
        import.meta.url,
      ).toString(),
    },
    547804438: {
      image: aceOfSpoonsImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/ace-of-spoons.webm",
        import.meta.url,
      ).toString(),
    },
    691145545: {
      image: dGradeImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/d-grade.webm",
        import.meta.url,
      ).toString(),
    },
    106: {
      image: fredAsquithImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/fred-asquith.webm",
        import.meta.url,
      ).toString(),
    },
    157511447: {
      image: domFutbolImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/dom-futbol.webm",
        import.meta.url,
      ).toString(),
    },
    609957761: {
      image: moyoImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/moyo.webm",
        import.meta.url,
      ).toString(),
    },
    95: {
      image: leilaLayzellImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/leila-layzell.webm",
        import.meta.url,
      ).toString(),
    },
    143: {
      image: samLewisImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/sam-lewis.webm",
        import.meta.url,
      ).toString(),
    },
    139: {
      image: millyPicklesImg.src,
      videoUrl: new URL(
        "./assets/creator-carousel/milly-pickles.webm",
        import.meta.url,
      ).toString(),
    },
  };

type CreatorData = {
  id: number;
  uuid: string;
  name: string;
  handle: string;
  creatorSrc: string | null;
  socialAvatarSrc: string | null;
  slug: string;
};

type Props = {
  creators: CreatorData[];
};

/**
 * Showcases real-time creator connections via WhatsApp with a creator carousel and testimonial.
 */
export const RealtimeChatClient = ({ creators }: Props) => {
  const carouselItems: CreatorVideoItem[] = creators.map((creator) => {
    const mappedMedia = CREATOR_MEDIA_BY_ID[creator.id];

    return {
      image: mappedMedia?.image ?? "",
      name: creator.name,
      handle: creator.handle,
      avatar: creator.creatorSrc,
      socialAvatar: creator.socialAvatarSrc,
      video: mappedMedia?.videoUrl ?? null,
      href: `/creators/${creator.slug}`,
    };
  });

  return (
    <section className="px-3 sm:px-6 md:px-8">
      <div className="mx-auto max-w-5xl space-y-4 sm:space-y-6">
        <FadeInSection className="space-y-2 sm:space-y-3">
          <WhatsAppLogo
            width={46}
            height={46}
            className="size-5.75 text-green-600 sm:size-8 lg:hidden"
          />
          <SectionEyebrow>Built for both brands and creators</SectionEyebrow>
          <div className="flex items-start justify-between gap-3">
            <Typography
              as="h2"
              weight="semibold"
              className="font-poppins text-4xl leading-[105%] tracking-[-1.44px] text-green-600 sm:text-5xl sm:tracking-[-1.92px] lg:text-7xl lg:tracking-[-2.88px]"
            >
              Connect with the world’s best creators and{" "}
              <span className="text-green-800">chat in real time</span>
            </Typography>
            <WhatsAppLogo
              width={46}
              height={46}
              className="hidden size-9 shrink-0 text-green-600 lg:block"
            />
          </div>
          <Typography
            size="sm"
            color="black"
            className="leading-2.75 sm:text-lg sm:leading-3"
          >
            Spend less time sifting through millions of creator profiles and
            more time connecting with top talent. Nutcake invites your favourite
            creators to instantly connect via WhatsApp. Creators share live
            audience stats straight from the Meta and TikTok APIs and chat with
            you on the platform.
          </Typography>
        </FadeInSection>

        <FadeInSection>
          <CreatorVideoCarousel items={carouselItems} showDetails />
        </FadeInSection>

        <FadeInSection>
          <TestimonialQuote
            quote="Live chat and uploading content to Nutcake means no more emailing WeTransfer links to brands"
            bubbleClassName="bg-green-50 text-green-600"
            avatarSrc={isaacHpAvatar.src}
            name="Isaac H.P"
            subtitle="TikTok · 4.1M Followers"
          />
        </FadeInSection>
      </div>
    </section>
  );
};
